import type React from 'react';
import { Fragment } from 'react';
import { Paragraph, Popover, TriggerText } from '@zillow/constellation-10';
import { parseTextWithLinks } from './parseTextWithLinks';

const LINK_REMOVED_LITERAL = '[Link removed]';
const LINK_REMOVED_BODY = 'A link was removed from this message to help keep you safe.';
const ON_IMPACT_UNDERLINE_COLOR = 'text.onImpact.neutral-fixed';
const onImpactTriggerTextStyles = {
  textDecorationColor: ON_IMPACT_UNDERLINE_COLOR,
  _hover: { textDecorationColor: ON_IMPACT_UNDERLINE_COLOR },
  _active: { textDecorationColor: ON_IMPACT_UNDERLINE_COLOR },
};

export function parseMessageText(
  text: string,
  onImpact?: boolean,
  onLinkClick?: (url: string, displayText?: string) => void,
  showLinkRemovedPopover?: boolean,
): Array<React.ReactNode> {
  if (!showLinkRemovedPopover || !text.includes(LINK_REMOVED_LITERAL)) {
    return parseTextWithLinks(text, onImpact, onLinkClick);
  }

  const segments = text.split(LINK_REMOVED_LITERAL);
  const result: Array<React.ReactNode> = [];

  segments.forEach((segment, i) => {
    if (segment) {
      result.push(<Fragment key={i}>{parseTextWithLinks(segment, onImpact, onLinkClick)}</Fragment>);
    }
    if (i < segments.length - 1) {
      result.push(
        <Popover
          key={`link-removed-${i}`}
          trigger={
            <TriggerText
              aria-label="Link removed — click for more information"
              css={onImpact ? onImpactTriggerTextStyles : undefined}
            >
              {LINK_REMOVED_LITERAL}
            </TriggerText>
          }
          header={<Paragraph textStyle="body-bold">Link removed</Paragraph>}
          body={<Paragraph>{LINK_REMOVED_BODY}</Paragraph>}
          useDismissProps={{ ancestorScroll: true }}
        />,
      );
    }
  });

  return result;
}
